import type {IssueEventType, PullRequestReviewState, TimelineItem} from '../../../page-data/payloads/timeline'

const STATIC_ACTION_TEXT: Partial<Record<TimelineItem['type'], string>> = {
  IssueComment: 'commented',
  CrossReference: 'mentioned this',
  PullRequestReviewThread: 'started a review thread',
  PullRequestRevisionMarker: 'New changes since last review',
}

const REVIEW_STATE_ACTION_TEXT: Partial<Record<PullRequestReviewState, string>> = {
  approved: 'approved these changes',
  changes_requested: 'requested changes',
  dismissed: 'had their review dismissed',
}

const ISSUE_EVENT_ACTION_TEXT: Partial<Record<IssueEventType, string>> = {
  review_requested: 'requested a review',
  review_request_removed: 'removed a review request',
}

export function TimelineItemAction({item}: {item: TimelineItem}) {
  if (item.type === 'IssueEvent') {
    const {eventType, assigneeLogin} = item.additionalInfo

    if ((eventType === 'assigned' || eventType === 'unassigned') && assigneeLogin) {
      return (
        <>
          {eventType} <strong>{assigneeLogin}</strong>
        </>
      )
    }

    return <>{ISSUE_EVENT_ACTION_TEXT[eventType] ?? eventType}</>
  }
  if (item.type === 'PullRequestReview') {
    return <>{REVIEW_STATE_ACTION_TEXT[item.additionalInfo.state] ?? 'reviewed'}</>
  }
  if (item.type === 'PullRequestCommit') {
    return <>{`pushed ${item.additionalInfo.sha.slice(0, 7)}`}</>
  }
  return <>{STATIC_ACTION_TEXT[item.type] ?? 'performed an action'}</>
}
